// @flow
import { ButtonLink, SidebarSection, Text } from 'bench-internal-theme';
import React from 'react';

import type { ClientRule } from './types';

type JournalEntryCategorizationClientRuleProps = {
  clientRule: ClientRule,
  showClientRuleEditForm: () => void,
};

const JournalEntryCategorizationClientRule = ({
  clientRule,
  showClientRuleEditForm,
}: JournalEntryCategorizationClientRuleProps) => {
  const { vendorContains, createdBy } = clientRule;
  return (
    <SidebarSection>
      <Text>Categorization Method: </Text>
      <ButtonLink onClick={showClientRuleEditForm} styleType="ghost">
        CLIENT RULE &quot;{vendorContains}&quot;
        {createdBy === 'CLIENT' ? <Text>&nbsp;(Client Generated)</Text> : undefined}
      </ButtonLink>
    </SidebarSection>
  );
};

export default JournalEntryCategorizationClientRule;
